import {of, Subject} from "rxjs";
import {TagDto} from "../domain";

export const tagsMock = [
  {name: 'Tag', tagId: 1, color: '#CDF9F3', companies: ['company-id'], type: 'custom'},
  {name: 'Test tag', tagId: 2, color: '#CDF9F3', companies: ['company-id'], type: 'custom'}
]

const confirmSaveSubject = new Subject<void>()
const confirmDeleteSubject = new Subject<void>()
const currentTagSubject = new Subject<number>()

export const tagsDetailFacadeMock = {
  findTagById: (tagId: number) => of(tagsMock[0]),
  currentTag: 1,
  listTagsFromCompanies: () => of(tagsMock),
  confirmSave: () => {
    confirmSaveSubject.next()
  },
  confirmDelete: () => {
    confirmDeleteSubject.next()
  },
  deleteTag: () => {
    return of(1)
  },
  createTag: (tag: TagDto) => of({...tag, id: 1}),
  editTag: (tag: TagDto) => of({...tag, id: 1}),
  setCurrentTag: (id: number) => currentTagSubject.next(id),
  get currentTag$() {
    return currentTagSubject.asObservable()
  },
  get confirmDelete$() {
    return confirmDeleteSubject.asObservable()
  },
  get saveConfirm$() {
    return confirmSaveSubject.asObservable()
  },
  validateTag: (tag: TagDto) => tag
}
